import Vue from 'vue'
import Vuex from 'vuex'
import mobileMenu from './mobileMenu.js'
import loading from './loading.js'
import authStorage from './auth.js'
import userStorage from './user.js'
import channelsStorage from './channels.js'
import searchStorage from './search.js'
import favlistStorage from './favlist.js'
import channelsTypesStorage from './channelsTypes.js'
import campaignsAdvertiserStorage from './campaignsAdvertiser.js'
import campaignsInfluencerStorage from './campaignsInfluencer.js'
import campaignsMembersAdvertiserStorage from './campaignsMembersAdvertiser.js'
import archetypesStorage from './archetypes.js'
import thematicCategoriesStorage from './thematicCategories.js'
import userNotificationsConfigStorage from './userNotificationsConfig.js'
import paymentsStorage from './payments.js'
import sitesStorage from './sites.js'
import contactStorage from './contact.js'
import advertisersStorage from './advertisers.js'
import campaignsMessagesStorage from './campaignsMessages.js'
import campaignsFilesStorage from './campaignsFiles.js'
import campaignsReportsStorage from './campaignsReports.js'
import campaignsCpcAdvertiserStorage from './campaignsCpcAdvertiser.js'
import campaignsCpcInfluencerStorage from './campaignsCpcInfluencer.js'
import campaignsReportsInfluencerStorage from './campaignsReportsInfluencer.js'
import api from '../connectors/Api'

Vue.use(Vuex)
const API = api()

const defaultLang = navigator.language === 'pl-PL' || navigator.language === 'pl-pl' || navigator.language === 'pl' ? 'pl' : 'en'

export default new Vuex.Store({
  modules: {
    mobileMenu: mobileMenu,
    loading: loading,
    auth: authStorage,
    user: userStorage,
    channels: channelsStorage,
    search: searchStorage,
    favlist: favlistStorage,
    channelsTypes: channelsTypesStorage,
    campaignsAdvertiser: campaignsAdvertiserStorage,
    campaignsInfluencer: campaignsInfluencerStorage,
    campaignsMembersAdvertiser: campaignsMembersAdvertiserStorage,
    archetypes: archetypesStorage,
    thematicCategories: thematicCategoriesStorage,
    userNotificationsConfig: userNotificationsConfigStorage,
    payments: paymentsStorage,
    sites: sitesStorage,
    contact: contactStorage,
    advertisers: advertisersStorage,
    campaignsMessages: campaignsMessagesStorage,
    campaignsFiles: campaignsFilesStorage,
    campaignsReports: campaignsReportsStorage,
    campaignsCpcAdvertiser: campaignsCpcAdvertiserStorage,
    campaignsCpcInfluencer: campaignsCpcInfluencerStorage,
    campaignsReportsInfluencer: campaignsReportsInfluencerStorage
  },
  state: {
    lang: defaultLang,
    systemLangs: []
  },
  mutations: {
    setLang (state, lang) {
      state.lang = lang
    },
    setSystemLangs (state, langs) {
      state.systemLangs = langs
    }
  },
  getters: {

  },
  actions: {
    loadSystemLangs ({ commit, state }) {
      return new Promise((resolve, reject) => {
        API.getAvailableLangs()
          .then((res) => {
            commit('setSystemLangs', res.body)
            resolve(res.body)
          })
          .catch((e) => {
            reject(e)
          })
      })
    }
  }
})
